import React, {Suspense} from 'react';
import useSestSearchParams from '@di-shared/features/diag/exchange/useSestSearchParams';
import {ROUTE_PATHS} from '@di-shared/routes';
import {Navigate, useSearchParams} from 'react-router-dom';
import SestExchangeRegister, {SestExchangeRegisterLoading} from '@di-shared/features/diag/exchange/register';
import {ccWebviewUtils} from '@shared/cci/features/webviewUtils';
import Header from '@di-shared/features/common/Header';
import HeaderBackButton from '@di-shared/features/common/HeaderBackButton';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {t} from '@di-shared/features/common/useInferableTranslation';
import ScrollToTopOnMount from '@di-shared/features/common/ScrollToTopOnMount';

interface SestExchangeRegisterPageProps {
  vin: string;
}

function SestExchangeRegisterPage({vin}: SestExchangeRegisterPageProps) {
  const [searchParams] = useSearchParams();
  const {getSestCodesFromParams} = useSestSearchParams({searchParams});
  const paramSestCodes = getSestCodesFromParams();
  const isAccessDI = !!searchParams.get('isAccessDI');

  if (paramSestCodes.length < 1) {
    return (
      <Navigate
        to={ROUTE_PATHS.DIAG_EXCHANGE_SELECT.getFullPath(vin)}
        replace={true}
      />
    );
  }
  return (
    <div className="wrap">
      <ScrollToTopOnMount />
      <Header
        left={window.history.length > 1 ? <HeaderBackButton /> : null}
        right={<HeaderCloseButton onClick={() => ccWebviewUtils.closeContent()} />}
      >
        <h1 className="title_xsmall_b nav_center_title">{t('T30027')}</h1>
      </Header>
      <Suspense fallback={<SestExchangeRegisterLoading />}>
        <SestExchangeRegister
          vin={vin}
          sestCodes={paramSestCodes}
          isAccessDI={isAccessDI}
        />
      </Suspense>
    </div>
  );
}

export default SestExchangeRegisterPage;
